import { ErrorMessage } from "@/app/components/error-message";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

import { useOrganisation } from "../api/get-my-organisation";
import { useMe } from "../api/get-my-organisations";

export function SwitchOrganisation() {
  const { data: me, isLoading, isSuccess, error } = useMe();
  const { setOrganisation, organisation } = useOrganisation();

  if (isLoading) {
    return (
      <div>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Switch Organisation</DropdownMenuLabel>
        <DropdownMenuItem>
          <Skeleton className="size-8 rounded-full bg-border" />
          <Skeleton className="h-4 w-24 bg-border" />
        </DropdownMenuItem>
      </div>
    );
  }

  if (!isSuccess) {
    return (
      <div>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Switch Organisation</DropdownMenuLabel>

        <ErrorMessage error={error} />
      </div>
    );
  }

  return (
    <div>
      <DropdownMenuSeparator />
      <DropdownMenuLabel>Switch Organisation</DropdownMenuLabel>
      {me.organisations.map((org) => (
        <DropdownMenuItem
          key={org.id}
          onClick={() => setOrganisation(org)}
          className={cn(
            "cursor-pointer",
            organisation?.id === org.id && "bg-accent",
          )}
        >
          <Avatar className="size-8">
            {org.logoURL && <AvatarImage src={org.logoURL} />}
            {!org.logoURL && (
              <AvatarFallback className="bg-border text-muted">
                {org.name.slice(0, 2)}
              </AvatarFallback>
            )}
          </Avatar>
          <span>{org.name}</span>
        </DropdownMenuItem>
      ))}
    </div>
  );
}
